<template>
  <div class="menulist">
    <el-menu :default-active="getActive" :default-openeds="menuOpeneds" :unique-opened="true" router>
      <template v-for="(menu, index) in menuList">
        <el-menu-item class="menuitem" :index="menu.url" @click="menuIndex(index)" v-if="!menu.children" :key="index">
          <i :class="getMenuIcon(menu.menuName)"></i>
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item>
        <el-submenu :index="index + ''" :key="index" v-else>
          <template slot="title">
            <i :class="getMenuIcon(menu.menuName)"></i>
            <span slot="title">{{ menu.menuName }}</span>
          </template>
          <el-menu-item :index="menuChild.url" v-for="(menuChild, _index) in menu.children" :key="_index">
            <span>{{ menuChild.menuName }}</span>
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>

export default {
  name: 'Menu',
  data () {
    return {
      menuOpeneds: []
    }
  },

  computed: {
    menuList () {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')).userInfoVO
      if (userInfo) {
        let child = userInfo.menus || [];
        return child;
      }
      return [];
    },
    getActive () {
      let path = this.$route.path.match(/\/?[^/]+/g);
      return path ? path[0] + path[1] : this.$route.path;
    }
  },
  methods: {
    menuIndex (index) {
      this.menuOpeneds = [index];
    },
    getMenuIcon (menuName) {
      let icon = ''
      switch (menuName) {
        case '电子现金':
          icon = 'el-icon-s-order'
          break
        case '服务台':
          icon = 'el-icon-menu'
          break
        case '数据':
          icon = 'el-icon-document'
          break
        case '任务':
          icon = 'el-icon-tickets'
          break
        case '设置':
          icon = 'el-icon-setting'
          break
      }
      return icon
    }
  },

}
</script>
<style lang='scss' scoped>
.menulist {
  position: relative;
  width: 200px;
  height: calc(100% - 90px);
  background-color: #fff;
  overflow-y: auto;
}

.menulist ::v-deep .el-menu {
  background-color: transparent;

  .el-menu-item {
    min-width: auto;
  }
}
</style>
